import { defineComponent } from '~/utils/alpine_types'

type Question = {
  id: number
  name: string
  maximum_score: number
}

type Quiz = {
  quiz_items: QuizItem[]
}

type QuizItem = {
  id: number | null
  quiz_question_id: number
  sort_order: number
  _destroy: boolean | undefined
}

export const quizForm = defineComponent((args: { quiz: Quiz; questions: Question[] }) => ({
  quiz: args.quiz,
  questions: args.questions,

  get quizItems() {
    return this.quiz.quiz_items.sort((a, b) => a.sort_order - b.sort_order)
  },

  get activeQuizItems() {
    return this.quizItems.filter((q) => !q._destroy)
  },

  get maximumScore(): number {
    return this.activeQuizItems.reduce(
      (acc, quizItems) =>
        acc + (this.questions.find(({ id }) => id === quizItems.quiz_question_id)?.maximum_score || 0),
      0,
    )
  },

  toggleQuestion(id: number) {
    let idx = this.quizItems.findIndex((q) => q.quiz_question_id === id)
    const quizItems = this.quizItems[idx]
    const newIdx = this.activeQuizItems.length + 1

    if (!quizItems) {
      this.quizItems.push({ id: null, quiz_question_id: id, sort_order: newIdx, _destroy: false })
      return
    }

    // Flag existing records for removal or fully remove new ones
    if (quizItems.id) {
      quizItems._destroy = !quizItems._destroy
    } else {
      this.quizItems.splice(idx, 1)
    }

    // Re-enabled questions get reset to the end, removing a question decrements subsequent questions' sort numbers
    if (quizItems && !quizItems._destroy) {
      quizItems.sort_order = newIdx
    } else {
      this.activeQuizItems.forEach((q) => q.sort_order > quizItems.sort_order && q.sort_order--)
    }
  },
}))
